
import './style.scss';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

import { Editor } from "react-draft-wysiwyg";
import { Box, Typography } from '@mui/material';
import { useLanguageContext } from '../../contexts/LanguageContext';
import { useEffect, useState } from 'react';
import { ContentState, EditorState, convertFromHTML, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';


interface IRichTextEditorProps {
    label?: string;
    name: string;
    value: string;
    handleChange: (value: string) => void;
    className?: string;
}


const RichTextEditor: React.FC<IRichTextEditorProps> = ({
    label = undefined,
    name,
    value,
    handleChange,
    className = '',
}) => {
    const { language } = useLanguageContext();

    const [editorState, setEditorState] = useState<EditorState>(EditorState.createEmpty());


    useEffect(() => {
        const html = convertFromHTML(value);
        const contentState = ContentState.createFromBlockArray(
            html.contentBlocks,
            html.entityMap,
        );

        setEditorState(EditorState.createWithContent(contentState));
        // eslint-disable-next-line
    }, []);


    useEffect(() => {
        const html = draftToHtml(convertToRaw(editorState.getCurrentContent()));
        handleChange(html);
        // eslint-disable-next-line
    }, [editorState]);

    return (
        <Box className={`richtexteditor-default ${className}`}>
            {
                label && <Typography className='richtexteditor-default-title'>
                    {label}
                </Typography>
            }

            <Editor
                editorState={editorState}
                onEditorStateChange={e => setEditorState(e)}
                locale={language.initials.toLowerCase()}
                toolbar={{
                    options: [
                        'inline', 
                        'blockType',
                        'list', 
                        'textAlign', 
                        'emoji', 
                        'history'
                    ]
                }}
                toolbarClassName='richtexteditor-default-toolbar'
                wrapperClassName='richtexteditor-default-wrapper'
                editorClassName='richtexteditor-default-editor'
            />

            <input type='hidden' readOnly={true} name={name}  value={value} />
        </Box>
    );
}


export default RichTextEditor;